import { useContext } from 'react';
import { FeatureFlagContext } from './index';

export const useFeatureFlags = () => {
  return useContext(FeatureFlagContext);
};
